import { addDays as addDays_, addMinutes as addMinutes_, isAfter, isEqual, isValid as isValid_, parseISO } from "date-fns";
import { formatInTimeZone as formatInTZ } from "date-fns-tz";
import { isNumeric, isString } from "./types";
export function parseDate(value) {
  if (isString(value)) {
    const parsed = parseISO(value);
    return isValid(parsed) ? parsed : new Date(value);
  } else if (isNumeric(value)) {
    return new Date(value);
  }
  return value;
}
export function formatInTimeZone(value, format = "d MMM yyyy - h:mma", timeZone = "Asia/Hong_Kong") {
  return formatInTZ(parseDate(value), timeZone, format);
}
export function addMinutes(value, amount) {
  return addMinutes_(parseDate(value), amount);
}
export function addDays(value, amount) {
  return addDays_(parseDate(value), amount);
}
export function isAfterOrEqual(value, compareValue) {
  const dateA = parseDate(value);
  const dateB = parseDate(compareValue);
  return isAfter(dateA, dateB) || isEqual(dateA, dateB);
}
export function isValid(value) {
  return isValid_(value);
}